import {
  MessageSquare,
  PlusCircle,
  FolderKanban,
  Bot,
  Users,
  Wrench,
  Workflow,
  Sparkles,
  BarChart3,
  Crown,
  Music2,
  CalendarDays,
  Music,
  MapPin,
  UserRound,
  Landmark,
  Building2,
  Cog,
  Package,
  CalendarClock,
  Megaphone,
  Award,
  Ticket,
  Globe2,
  Radio,
} from 'lucide-react';

/** Primary sidebar nav — paths match existing app routes. */
export const NavData = [
  { path: 'chat', name: 'Xavi Chat', icon: MessageSquare },
  { path: 'create-agent', name: 'Create Agent', icon: PlusCircle },
  { path: 'projects', name: 'Projects', icon: FolderKanban },
  { path: 'agents', name: 'Agents', icon: Bot },
  { path: 'team', name: 'Team', icon: Users },
  { path: 'tools', name: 'Tools', icon: Wrench },
  { path: 'skills', name: 'Skills', icon: Sparkles },
  { path: 'workflows', name: 'Workflows', icon: Workflow },
  { path: 'artist-intelligence', name: 'Artist Intelligence', icon: Music2 },
];

/** Grouped "Live Intelligence" section (renders under its own sidebar header). */
export const LiveIntelNavData = [
  { path: 'events-catalog', name: 'Events', icon: CalendarDays },
  { path: 'festivals', name: 'Festivals', icon: Sparkles },
  { path: 'artists', name: 'Artist', icon: Music2 },
  { path: 'genres', name: 'Genres', icon: Music },
  { path: 'locations', name: 'Locations', icon: MapPin },
];

/** Grouped "Network Intelligence" section. */
export const NetworkIntelNavData = [
  { path: 'directory-agents', name: 'Agents', icon: UserRound },
  { path: 'agencies', name: 'Agencies', icon: Landmark },
  { path: 'productions', name: 'Productions', icon: Cog },
  { path: 'vendors', name: 'Vendors', icon: Package },
  { path: 'venues', name: 'Venues', icon: Building2 },
  { path: 'bookers', name: 'Bookers', icon: CalendarClock },
  { path: 'promoters', name: 'Promoters', icon: Megaphone },
];

/** Grouped "Reports" section (touring data, box scores, shows). */
export const ReportsNavData = [
  { path: 'reports', name: 'Reports', icon: BarChart3, exact: true },
  { path: 'reports/artists', name: 'Artists', icon: Music2 },
  { path: 'reports/tours', name: 'Tours', icon: CalendarClock },
  { path: 'reports/boxscores', name: 'Box Scores', icon: Award },
  { path: 'reports/shows', name: 'Shows', icon: Ticket },
];

/** Grouped "Discover" section (geographies + livestreams), above Reports. */
export const DiscoverNavData = [
  { path: 'geographies', name: 'Geographies', icon: Globe2 },
  { path: 'streams', name: 'Livestreams', icon: Radio },
];

export const SecondaryNavData = [
  { path: 'analytics', name: 'Analytics', icon: BarChart3 },
  { path: 'upgrade-plan', name: 'Upgrade Plan', icon: Crown },
];
